import { FolderUpIcon, UploadIcon } from '@air/design-icons';
import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';
import { cn } from '@air/utils-tailwind';

import { getMenuOption, type ImportOptions } from '~/constants/MenuOptions';
import { getImportLogo } from '~/utils/dropdownMenuOptions/getAddMenuOptions';
import { type ImportSourceType } from '~/utils/ImportUtils';

export type GetHeaderUploadMenuOptionsParams = {
  exposeImportSources: ImportSourceType[];
  onImportFrom: ((importOption: ImportOptions) => void) | undefined;
  onUploadFilesFromComputer: (() => void) | undefined;
  onUploadFoldersFromComputer: (() => void) | undefined;
  ui2026: boolean;
};

export const getHeaderUploadMenuOptions = ({
  exposeImportSources,
  onImportFrom,
  onUploadFilesFromComputer,
  onUploadFoldersFromComputer,
  ui2026,
}: GetHeaderUploadMenuOptionsParams): DropdownMenuOption[] => {
  const menuOptions: DropdownMenuOption[] = [];

  if (onUploadFilesFromComputer) {
    menuOptions.push({
      id: 'upload-files',
      label: 'File Upload',
      onSelect: onUploadFilesFromComputer,
      prefix: ui2026 ? <UploadIcon className="ads:text-icon-subtle text-gray-9" size="sm" /> : <UploadIcon size="sm" />,
      type: 'item',
    });
  }

  if (onUploadFoldersFromComputer) {
    menuOptions.push({
      id: 'upload-folders',
      label: 'Folder Upload',
      onSelect: onUploadFoldersFromComputer,
      prefix: <FolderUpIcon className={cn({ 'ads:text-icon-subtle text-gray-9': ui2026 })} size="sm" />,
      type: 'item',
    });
  }

  if (onImportFrom && exposeImportSources.length > 0) {
    if (menuOptions.length > 0) {
      menuOptions.push({
        id: 'import-seperator',
        type: 'separator',
      });
    }

    menuOptions.push({
      id: 'import-title',
      label: 'Import from...',
      type: 'title',
    });

    exposeImportSources.forEach((source) => {
      const id: ImportOptions = source === 'googleDrive' ? 'import-from-drive' : `import-from-${source}`;
      const option = getMenuOption(id);

      menuOptions.push({
        id,
        label: option?.label,
        onSelect: () => onImportFrom(id),
        prefix: getImportLogo(source),
        type: 'item',
      });
    });
  }

  return menuOptions;
};
